var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
var EActiveType;
(function (EActiveType) {
    EActiveType["UN_SELECTED"] = "0";
    EActiveType["SELECTED"] = "1";
})(EActiveType || (EActiveType = {}));
var AddGoodTable = (function (_super) {
    __extends(AddGoodTable, _super);
    function AddGoodTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.EActiveType = EActiveType;
        return _this;
    }
    AddGoodTable.prototype.selectionChange = function (rows, row) {
        this.$emit('selectChange', rows, row);
    };
    AddGoodTable.prototype.selectAll = function (rows) {
        this.$emit('selectChange', rows, null, true);
    };
    __decorate([
        Prop({
            required: true,
            type: Number
        })
    ], AddGoodTable.prototype, "tableHeight", void 0);
    __decorate([
        Prop({
            required: true,
            type: Array
        })
    ], AddGoodTable.prototype, "data", void 0);
    __decorate([
        Prop({
            required: true,
            type: String
        })
    ], AddGoodTable.prototype, "activeName", void 0);
    AddGoodTable = __decorate([
        Component
    ], AddGoodTable);
    return AddGoodTable;
}(Vue));
export default AddGoodTable;
